export default __webpack_public_path__ + "static/media/Etterbeek2.af78a736.webp";